// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78caf668","833":"9865f9bd"}[chunkId] + ".chunk.js";
};